import { Component, OnInit, ViewChild, ElementRef, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { UserService } from '../../pages/auth/UserDetails/user.service';
import { GlobalStorage } from '../../../core/Gloabl/Global';
import { Notification } from '../../../core/Notifications/Notification';
import { ProfileService } from 'src/app/modules/profile-module/profile.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  username: string;
  userdata: any;
  useremail: string;
  Image_Url;
  test: any = 'Welcome Test';
  message: any;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private user: UserService,
    private store: GlobalStorage,
    private Notifi: Notification,
    private service: ProfileService
  ) { }

  ngOnInit(): void {

    //this.Notifi.successmsg(this.username +" logged Successfully.");
    this.service.currentUserData.subscribe(data => {
      console.log('Test data')
      console.log(data)
      if (data != undefined) {
        console.log('Data test')
        console.log(data)
        this.userdata = data;
        this.Image_Url = 'data:image/jpeg;base64,' + this.userdata.imagebyte;
      }
    })
    this.service.currentUserImage.subscribe(data => {
      console.log('Test image')
      console.log(data)
      this.Image_Url = data;
    })
    this.get_profile();
    //this.Notifi.successmsg(this.username +" logged Successfully.");
  }

  receivename($event: string) {
    this.test = $event;
    console.log(this.test)
  }


  toggleSidebar(e) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');
  }

  /**
   * Logout
   */
  onLogout(e) {
    e.preventDefault();
    this.user.logout();
    this.router.navigate(['/auth/login']);
  }

  get_profile() {
    this.service.Get_Userprofile()
      .subscribe((data) => {
        this.userdata = data;
        this.Image_Url = 'data:image/jpeg;base64,' + this.userdata.imagebyte;
        //this.Image_Url= { url: `${environment.API_Base_URL}` +`User/GetProfile_Images?filename=${this.userdata.image}`};
        if (this.Image_Url == '') {
          this.Image_Url = { url: '/assets/images/profile.png' }
        }
        if (this.username == '') {
          this.username = ''
        }
      })
  }

}